var _path, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2134 2134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,1149.94l0,-0.337l256.023,0l0.156,0.342l-256.179,-0.005Zm288.648,-115.673l-76.589,0c-24.92,-80.56 -39.086,-165.322 -39.086,-253.901c-0,-330.114 219.774,-636.224 520.718,-636.224c208.842,0 363.808,137.341 459.462,332.172c95.648,-194.82 250.615,-332.172 459.462,-332.172c300.979,0 520.718,306.162 520.718,636.224c0,706.554 -980.18,1208.82 -980.18,1208.82c0,0 -660.255,-317.855 -896.974,-839.242l584.746,0l92.945,-165.223l108.563,379.987l254.236,-326.873l317.745,-0l0,-115.315l-374.146,-0l-149.368,192.046l-122.067,-427.221l-195.344,347.284l-433.591,0l-0,-51.25l403.617,0l180.65,-321.159c10.138,-18.024 30.115,-28.189 50.653,-25.774c20.537,2.415 37.612,16.936 43.293,36.82c0,-0 94.327,330.131 94.327,330.131l87.376,-112.342c9.709,-12.484 24.639,-19.785 40.454,-19.785l374.146,-0c28.305,-0 51.25,22.945 51.25,51.25l0,115.315c0,28.304 -22.945,51.25 -51.25,51.25l-292.68,-0l-238.847,307.087c-11.849,15.235 -31.254,22.521 -50.202,18.85c-18.949,-3.671 -34.228,-17.677 -39.53,-36.235l-74.828,-261.907l-32.734,58.191c-9.078,16.137 -26.153,26.123 -44.668,26.123l-501.745,0c224.439,408.434 703.015,673.248 813.237,730.249c81.091,-44.511 364.691,-209.178 598.73,-455.633c179.362,-188.878 330.936,-426.087 330.936,-695.445c0,-301.122 -194.878,-584.974 -469.468,-584.974c-188.933,0 -326.929,127.265 -413.457,303.508c-8.614,17.546 -26.459,28.664 -46.005,28.664c-19.546,-0 -37.39,-11.118 -46.004,-28.664c-86.533,-176.253 -224.53,-303.508 -413.458,-303.508c-274.558,0 -469.468,283.805 -469.468,584.974c-0,70.172 9.483,137.792 26.482,202.651l89.193,0c-28.305,0 -51.25,22.946 -51.25,51.25Zm4.351,0l-4.351,0c0.005,-2.162 1.651,-1.895 4.351,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 167.496,
    y: 983.189,
    width: 208.203,
    height: 51.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 167.496,
    y: 1149.61,
    width: 216.709,
    height: 51.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.527,1037.64l-0,108.913c-0,30.055 -24.401,54.456 -54.457,54.456l-123.614,-0c-30.055,-0 -54.456,-24.401 -54.456,-54.456l-0,-108.913c-0,-30.055 24.401,-54.456 54.456,-54.456l123.614,0c30.056,0 54.457,24.401 54.457,54.456Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 983.189,
    width: 375.698,
    height: 51.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1149.61,
    width: 384.205,
    height: 51.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,983.189l51.08,0l0,217.496l-51.08,0l0,-217.496Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.e74c92fe45a52ccc008f2da666a3e165.svg";
export { ForwardRef as ReactComponent };